import { DisplayTypeEnum } from '@interfaces/DisplayTypeEnum'

export const initialValues = {
  searchText: '',
  displayType: DisplayTypeEnum.WEB,
  bookType: null,
  categoryIds: [],
  penNameIds: [],
}
